import { FaGithub } from "react-icons/fa";
import { MdRemoveRedEye } from 'react-icons/md'
import './project.css';


export const SoloProjects = () => {

    const gitGo = (link) => {
        window.open(link, `_blank`);
    }

    const seeGo = (link) => {
        window.open(link, `_blank`);
    }

    return (
        <div className="project_main">

            <div className="project_con">
                <div data-aos="flip-right">
                    <iframe width="410" height="230" src="https://www.youtube.com/embed/UhzgZ6gZmyM?autoplay=1&mute=1"
                        title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; 
                 clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>
                    </iframe>
                </div>

                <div data-aos="flip-left" className='details_div'>
                    <div className="project_heading">
                        <p>Sugared and Spiced Clone</p>
                        <p>(Ecommerce Website)</p>
                    </div>
                    <div className='project_tech'>
                        <p>Tech Stacks:</p>
                        <p>React, Context, Tailwind Css, NodeJs, MongoDB, Express</p>
                    </div>
                    <div className='project_feature'>
                        <p>Features:</p>
                        <ul>
                            <li>Intersection Observer API for nice UI</li>
                            <li>Loading Screen</li>
                            <li>Infinite Scrolling</li>
                            <li>4 types of filter</li>
                            <li>Filter through Search</li>
                        </ul>
                    </div>
                    <div className="link_div">
                        <FaGithub onClick={() => gitGo(`https://github.com/Neha-251/Sugared-and-Spiced-clone`)} className="gitLogo" />
                        <MdRemoveRedEye onClick={() => seeGo(`https://sugared-and-spiced-clone.vercel.app`)} className="gitLogo" />
                    </div>

                </div>
            </div>

            <div className="project_con">
                <div data-aos="flip-right">
                    <iframe width="410" height="230" src="https://www.youtube.com/embed/6Zwlo0esYdc?autoplay=1&mute=1" title="YouTube video player"
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div data-aos="flip-left" className='details_div'>
                    <div className="project_heading">
                        <p>Resource Management</p>
                        <p>(Admin Portal)</p>
                    </div>
                    <div className='project_tech'>
                        <p>Tech Stacks:</p>
                        <p>React, Redux</p>
                    </div>
                    <div className='project_feature'>
                        <p>Features:</p>
                        <ul>
                            <li>Form Validation</li>
                            <li>Pagination</li>
                            <li>Sorting</li>
                            <li>Loading Screen</li>
                        </ul>
                    </div>
                    <div className="link_div">
                        <FaGithub onClick={() => gitGo(`https://github.com/Neha-251/Resources-management-Project`)} className="gitLogo" />
                        <MdRemoveRedEye onClick={() => seeGo(`https://resources-management-project.vercel.app`)} className="gitLogo" />
                    </div>
                </div>
            </div>


            <div className="project_con">
                <div data-aos="flip-right">
                    <iframe width="410" height="230" src="https://www.youtube.com/embed/zDdei2tbXhM?autoplay=1&mute=1" title="YouTube video player"
                        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>

                <div data-aos="flip-left" className='details_div'>
                    <div className="project_heading">
                        <p>Social Media</p>
                        <p>(Social media Website)</p>
                    </div>
                    <div className='project_tech'>
                        <p>Tech Stacks:</p>
                        <p>React, Context, CSS, NodeJs, MongoDB, Express</p>
                    </div>
                    <div className='project_feature'>
                        <p>Features:</p>
                        <ul>
                            <li>Password Hashing</li>
                            <li>Loading Screen</li>
                            <li>Upload Profile Picture</li>
                            <li>Post, Like, Comment any post</li>
                            <li>Connct with Friends, chat with them</li>
                        </ul>
                    </div>
                    <div className="link_div">
                        <FaGithub onClick={() => gitGo(`https://github.com/Neha-251/Social-Media-App`)} className="gitLogo" />
                        <MdRemoveRedEye onClick={() => seeGo(`https://social-media-app-dun.vercel.app`)} className="gitLogo" />
                    </div>
                </div>
            </div>


        </div>

    )
}